var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusterbeispiel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 380 230",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mustertext"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.36153,7.82592,86.4489)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.172,
    y: 58.807,
    width: 290.004,
    height: 111.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.641,
    width: 380,
    height: 204.359,
    style: {
      fill: "white",
      stroke: "rgb(128,128,128)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,22.932,65.8331)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "47.806px",
    y: "53.188px",
    style: {
      fontFamily: "'AvenirNext-Regular', 'Avenir Next', sans-serif",
      fontSize: 64,
      fill: "rgb(128,128,128)"
    }
  }, "Eigenes"), /*#__PURE__*/React.createElement("text", {
    x: "63.262px",
    y: "117.188px",
    style: {
      fontFamily: "'AvenirNext-Regular', 'Avenir Next', sans-serif",
      fontSize: 64,
      fill: "rgb(128,128,128)"
    }
  }, "Muster"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusterbeispiel);
export default __webpack_public_path__ + "static/media/musterbeispiel.f54a4f80428040071c1208e82efc2883.svg";
export { ForwardRef as ReactComponent };